
    /**
    * 后台获取所有领域
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid17407 {}
  /**
 * YResult<YListData<RealmInfoDto>> :YResult
 */
export class IResid17407 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * YListData
   */
  data?: {
    /**
     * T
     */
    list?: {
      /**
       * 领域编号
       */
      type?: {};
      /**
       * 领域名称
       */
      name?: {};
    }[];
    totalNumber?: {};
    rowId?: {};
  };
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid17407, IResid17407['data'] > = (data?) =>  request({
        method: 'GET',
        url: '/admin/anchor/list_realm_info',
        params: data
      }) 
  export default http